const axisPadding = 54;

function MunicipalityRow({
  runs,
  names,
  totalCount,
  activeMunicipalityId,
  onMunicipalityClick,
  position,
}) {
  return (
    <div className={`municipality-axis__row municipality-axis__row--${position}`}>
      {runs.map((run, runIndex) => {
        const name = run.municipalityId
          ? names?.[run.municipalityId] || run.municipalityId
          : null;
        const isActive = activeMunicipalityId
          && run.municipalityId === activeMunicipalityId;
        const isClickable = Boolean(run.municipalityId);

        return (
          <div
            className="municipality-axis__run"
            key={`${position}-${run.municipalityId ?? 'onbekend'}-${run.startIndex}`}
            style={{ flexGrow: run.count / (totalCount || 1) }}
          >
            {runIndex > 0 && <span className="municipality-axis__tick" aria-hidden="true" />}
            {name
              ? (
                  <button
                    type="button"
                    className={`municipality-axis__label${isActive ? ' municipality-axis__label--active' : ''}`}
                    onClick={() => isClickable && onMunicipalityClick(run.municipalityId)}
                    title={name}
                  >
                    {name}
                  </button>
                )
              : <span className="municipality-axis__label municipality-axis__label--empty" />}
          </div>
        );
      })}
    </div>
  );
}

function MunicipalityAxis({
  leftRuns,
  rightRuns,
  names,
  totalCount,
  activeMunicipalityId,
  onMunicipalityClick,
}) {
  return (
    <div
      className="municipality-axis"
      style={{ paddingLeft: `${axisPadding}px`, paddingRight: `${axisPadding}px` }}
    >
      <MunicipalityRow
        runs={leftRuns}
        names={names}
        totalCount={totalCount}
        activeMunicipalityId={activeMunicipalityId}
        onMunicipalityClick={onMunicipalityClick}
        position="top"
      />
      <div className="municipality-axis__arrow" aria-label="Stroomrichting van bron naar monding">
        <span className="municipality-axis__arrow-line" />
        <span className="municipality-axis__arrow-head" />
      </div>
      <MunicipalityRow
        runs={rightRuns}
        names={names}
        totalCount={totalCount}
        activeMunicipalityId={activeMunicipalityId}
        onMunicipalityClick={onMunicipalityClick}
        position="bottom"
      />
    </div>
  );
}

export default MunicipalityAxis;
